import { useTranslation } from 'react-i18next'
import { api } from '../api/client.js'
import { useApi } from '../api/useApi.js'
import { SOCIAL_ICONS } from './socialIcons.js'

// Black brand marks would vanish in the dark theme: those follow the text colour.
const MONO = new Set(['x', 'tiktok', 'threads'])

/** Brand buttons for the networks configured on the server (SOCIAL_* in .env). */
export default function SocialLinks({ title = false, className = '' }) {
  const { t } = useTranslation()
  const { data } = useApi(() => api.appConfig())
  const links = (data?.social ?? []).filter((l) => SOCIAL_ICONS[l.network])
  if (!links.length) return null
  return (
    <div className={`flex flex-col gap-2.5 ${className}`}>
      {title ? <span className="text-sm font-extrabold tracking-[1.2px] text-subtle uppercase">{t('social.title')}</span> : null}
      <ul className="m-0 flex list-none flex-wrap gap-2.5 p-0">
        {links.map(({ network, url }) => {
          const icon = SOCIAL_ICONS[network]
          return (
            <li key={network}>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={icon.title}
                title={icon.title}
                className="flex size-11 items-center justify-center rounded-full border-[1.5px] border-line bg-surface text-ink transition hover:border-ink"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                  <path d={icon.path} fill={MONO.has(network) ? 'currentColor' : icon.color} />
                </svg>
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
